'use strict';

var React = require('react');
require('prop-types');
var Button = require('./Button/Button.js');
var Grid = require('../../Layout/Grid/Grid.js');
var Card = require('../../Surfaces/Cards/Card.js');
var CardContent = require('../../Surfaces/Cards/CardContent.js');
var Add = require('../../../node_modules/@material-ui/icons/Add.js');
var withStyles = require('../../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    button: {
      height: '100%',
      border: 'none',
      background: 'none',
      padding: 0,
      '&:hover': {
        background: 'none'
      }
    },
    buttonRoot: {
      textTransform: 'none',
      color: theme.palette.black.primary
    },
    wrapper: {
      height: '100%',
      width: '100%',
      border: '1.5px solid #2196f3',
      borderRadius: '8px !important',
      background: 'rgba(33, 150, 243, .1)',
      cursor: 'pointer !important',
      position: 'relative',
      overflow: 'hidden'
    },
    transparency: {
      position: 'absolute',
      zIndex: 801,
      background: '#fff',
      height: '100%',
      width: '100%',
      margin: '-16px 0 0 -16px',
      '&:hover': {
        background: 'rgba(33, 150, 243, .05)'
      },
      '&::-webkit-transition': {
        transition: 'all .5s'
      },
      transition: 'all .5s',
      transitionTimingFunction: 'ease-in-out'
    },
    iconItem: {
      display: 'flex'
    },
    titlePosition: {
      margin: '16px !important'
    },
    title: {
      fontSize: 16,
      fontWeight: 400,
      lineHeight: 1.5,
      letterSpacing: '0.00938em'
    },
    plusIcon: {
      top: 'calc(50% - 16px)',
      left: 'calc(50% - 16px)',
      display: 'flex',
      position: 'absolute',
      zIndex: 1
    },
    skeletonContentMargin: {
      marginTop: 44
    }
  };
};

var CardButtonBig = function CardButtonBig(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      buttonHeight = _ref.buttonHeight,
      overlayIcon = _ref.overlayIcon,
      skeletonComponent = _ref.skeletonComponent,
      onClick = _ref.onClick,
      classes = _ref.classes;
  return React__default["default"].createElement(Button["default"], {
    fullWidth: true,
    onClick: onClick,
    className: classes.button,
    classes: {
      root: classes.buttonRoot
    }
  }, React__default["default"].createElement(Card, {
    className: classes.wrapper,
    elevation: 0,
    style: {
      height: buttonHeight
    }
  }, React__default["default"].createElement(CardContent, null, React__default["default"].createElement(Grid, {
    container: true,
    className: classes.transparency
  }, React__default["default"].createElement(Grid, {
    container: true,
    spacing: 1,
    className: classes.titlePosition
  }, React__default["default"].createElement(Grid, {
    item: true,
    className: classes.iconItem
  }, icon), React__default["default"].createElement(Grid, {
    item: true,
    className: classes.title
  }, title)), React__default["default"].createElement(Grid, {
    item: true,
    className: classes.plusIcon
  }, overlayIcon)), React__default["default"].createElement("div", {
    className: classes.skeletonContentMargin
  }), skeletonComponent)));
};

CardButtonBig.defaultProps = {
  onClick: function onClick() {},
  overlayIcon: React__default["default"].createElement(Add, {
    color: "primary",
    fontSize: "large"
  }),
  buttonHeight: null
};
var BigCardButton = withStyles(styles)(CardButtonBig);

module.exports = BigCardButton;
